import { render, staticRenderFns } from "./CouponVoucherItem.vue?vue&type=template&id=6e842d94&"
import script from "./CouponVoucherItem.vue?vue&type=script&lang=js&"
export * from "./CouponVoucherItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports